import React from 'react'
import PropTypes from 'prop-types'
import NotificationMenu from './NotificationMenu'
import WhatsAppNotificationMenu from './WhatsAppNotificationMenu'
import LeadsMenu from './LeadsMenu'
import UserInfo from './UserInfo'
import NavBreadcrumbs from './NavBreadcrumbs'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import logoFull from '../../images/logo-full.svg'
import logoMin from '../../images/logo-min.svg'
import Tooltip from '@material-ui/core/Tooltip'
import HelpMenu from '../home/HelpMenu'
import PillComponent, {PILL_COLOR} from 'common/Pill/Pill.component'
import { useSelector } from 'react-redux'
import useBackButtonNavigation from 'common/hooks/useBackButtonNavigation.js'
import PullToRefreshBox from '../common/PullToRefresh/PullToRefreshBox.js'
import { useRefresh } from '../common/PullToRefresh/PullToRefreshContext.js'

const LOGO_TOOLTIP = 'Asofix - Sistema de gestión de concesionarios'

const HeaderBar = ({
  isMobile,
  sidebarCollapsed,
  forceCloseNotificationsFlag,
  setForceCloseNotificationsFalse,
  forceCloseNotifications,
  toggleOpen,
  toggleCollapse,
  closeMenu,
  hasSirenaKey,
  children,
}) => {
  const contentContainerRef = React.useRef(null)
  const [forceCloseWhatsApp, setForceCloseWhatsApp] = React.useState(false)
  const [forceCloseGeneralLocal, setForceCloseGeneralLocal] = React.useState(false)
  const headerClassName = `header-content ${
    isMobile ? 'mobile' : 'desktop'
  } ${sidebarCollapsed ? 'collapsed' : 'fullwidth'}`
  const isDemo = useSelector(state => state.common.user.license.isDemo)

  React.useEffect(() => {
    if (forceCloseNotificationsFlag) {
      setForceCloseWhatsApp(true)
    }
  }, [forceCloseNotificationsFlag])

  const handleMenuClick = () =>  {
    if(isMobile) {
      toggleOpen()
    } else {
      toggleCollapse()
    }
  }

  const logo = isMobile ? logoMin : logoFull
  const isMobileSystem = useSelector(state => state.common.user.isMobileSystem)
  useBackButtonNavigation(isMobileSystem)

  const { refreshHandler, isDrawerOpen } = useRefresh() 

  const handleManualRefresh = async () => {
    if (refreshHandler) {
      try {
        await Promise.all([
             refreshHandler(),
             new Promise(resolve => setTimeout(resolve, 800))
        ])
      } catch (e) {
        console.error("Error refresh", e)
      }
    }
  }


  return (
    <div className="header-content-bg" ref={contentContainerRef}>
        <div className={headerClassName}>
          <IconButton
            className="menu-button"
            color="inherit"
            onClick={handleMenuClick}
          >
            <MenuIcon />
          </IconButton>
          <Tooltip
            title={LOGO_TOOLTIP}
            placement="bottom"
            disableTouchListener
            className="tooltip-logo"
          >
            <img src={logo} alt="logo-asofix" className={`${isDemo ? "logo-full-and-pill":"logo-full"}`}></img>
          </Tooltip>
          { isDemo && (
                    <div className="pill-company-demo">
                    <PillComponent
                        label="DEMO"
                        color={PILL_COLOR.YELLOW_HIGHLIGHT}
                    /></div>)
                }
          <NavBreadcrumbs />
          {hasSirenaKey &&  <LeadsMenu />}
          <WhatsAppNotificationMenu
            closeSideMenu={closeMenu}
            forceCloseFlag={forceCloseWhatsApp}
            setForceCloseFlagFalse={() => setForceCloseWhatsApp(false)}
            onOpen={() => setForceCloseGeneralLocal(true)}
          />
          <NotificationMenu
            closeSideMenu={closeMenu}
            forceCloseNotificationsFlag={
              forceCloseNotificationsFlag || forceCloseGeneralLocal
            }
            setForceCloseNotificationsFalse={() => {
              setForceCloseNotificationsFalse()
              setForceCloseGeneralLocal(false)
            }}
            onOpen={() => setForceCloseWhatsApp(true)}
          />
          <HelpMenu />
          <UserInfo
            closeSideMenu={closeMenu}
            forceCloseNotifications={forceCloseNotifications}
            isMobile={isMobile}
          />
        </div>
      {isMobileSystem ? (
        <div className="content-children">
          <PullToRefreshBox 
              onRefresh={handleManualRefresh}
              disabled={!refreshHandler || isDrawerOpen}
          >
              {children}
          </PullToRefreshBox>
        </div>
      ) : (
        <div className="content-children">{children}</div>
      )
      }
    </div>
  )
}

HeaderBar.propTypes = {
  style: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.object,
}

export default HeaderBar
